import { render, staticRenderFns } from "./form-face.vue?vue&type=template&id=680497d5"
import script from "./form-face.vue?vue&type=script&lang=js"
export * from "./form-face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports